import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Document } from '../../model/document';
import { DocumentValue } from '../../model/document-value';
import { TemplateAttribute } from '../../model/template-attribute';
import { TemplateAttributeMode } from '../../model/template-attribute-mode.enum';
import { TranslationService } from '@sdbn/common';
@Component({
    selector: 'app-template-attribute-boolean-mandatory',
    templateUrl: './boolean-mandatory.component.html',
    styleUrls: ['./boolean-mandatory.component.scss'],
    standalone: false
})
export class AttributeBooleanMandatoryComponent implements OnInit {

  private VALUE_TRUE = 'true';
  private VALUE_FALSE = 'false';
  private VALUE_UNDEFINED = 'undefined';

  checkboxYesControl = new UntypedFormControl(false);
  checkboxNoControl = new UntypedFormControl(false);

  yesNoFormGroup = new UntypedFormGroup({
    checkboxYes: this.checkboxYesControl,
    checkboxNo: this.checkboxNoControl
  });

  attributeMode = TemplateAttributeMode;

  documentValue: DocumentValue = null;

  @Input() document: Document;
  @Input() templateAttribute: TemplateAttribute;

  @Input() form: UntypedFormGroup;

  constructor(
    public translationService: TranslationService) {

      this.checkboxYesControl.valueChanges.subscribe(value => {
        console.log('checkboxYesControl', value);
        if (value === true) {
          this.checkboxNoControl.setValue(false, {emitEvent: false});
        }
        this.calculateDocumentValueAndSetCheckboxStatus();
      });

      this.checkboxNoControl.valueChanges.subscribe(value => {
        console.log('checkboxNoControl', value);
        if (value === true) {
          this.checkboxYesControl.setValue(false, {emitEvent: false});
        }
        this.calculateDocumentValueAndSetCheckboxStatus();
      });

  }



  ngOnInit(): void {
    this.extractDocumentValueByKey();
  }

  private calculateDocumentValueAndSetCheckboxStatus() {
    const yes = this.checkboxYesControl.value;
    const no = this.checkboxNoControl.value;
    if (yes) {
      this.documentValue.value = this.VALUE_TRUE;
    } else if (no) {
      this.documentValue.value = this.VALUE_FALSE;
    } else {
      this.documentValue.value = this.VALUE_UNDEFINED;
    }
    this.applyValueToForm();
  }

  private applyValueToForm() {
    const ctrl = this.form.controls[this.templateAttribute.key];
    if (ctrl != null) {
      ctrl.setValue(this.documentValue.value);
    }
  }

  private extractDocumentValueByKey() {
    // find document value to store it in
    for (const value of this.document.values) {
      if (value.key === this.templateAttribute.key) {
        this.documentValue = value;
        this.setComboboxStatus();
        break;
      }
    }
  }

  private setComboboxStatus() {
    if (this.documentValue.value === this.VALUE_TRUE) {
      this.checkboxYesControl.setValue(true, {emitEvent: false});
      this.checkboxNoControl.setValue(false, {emitEvent: false});
    } else if (this.documentValue.value === this.VALUE_FALSE) {
      this.checkboxYesControl.setValue(false, {emitEvent: false});
      this.checkboxNoControl.setValue(true, {emitEvent: false});
    } else {
      this.checkboxYesControl.setValue(false, {emitEvent: false});
      this.checkboxNoControl.setValue(false, {emitEvent: false});
    }
  }


}
